<template>
    <div class="report_grade">
        <div class="report_grade_title">
            <p class="fl">报告评级</p>
            <div class="fr report_stockpick">
                <span>选股结果仅供对比参考</span>
                <a target="_blank" :href="'http://x.10jqka.com.cn/stockpick/search?w=' + query" @click="iwencaiPoint"><vue-button type="blue" size="small">查看问财选股</vue-button></a>
            </div>
        </div>
        <div class="report_grade_main" v-if="transactiontype === '1'">
            <div class="average_rise_fall">
                <p>最大预期年化收益率</p>
                <p class="backtestweek"> <span>{{ reportData.maxAnnualYield[0] | safePercentFixedTwo }}</span>, 回测持股周期 <span>{{ reportData.maxAnnualYield[1] }}</span> 天 </p>
            </div>
            <div class="max_win_rise">
                <p>最大成功率</p>
                <p class="backtestweek"> <span>{{ reportData.maxWinRate[0] | safePercentFixedTwo }}</span>, 回测持股周期 <span>{{ reportData.maxWinRate[1] }}</span> 天 </p>
            </div>
            <div class="report_grade_img" :class="reportData.level | levelType"></div>
        </div>

        <div class="report_grade_main" v-else>
            <div class="average_rise_fall">
                <p>最大预期年化收益率</p>
                <p class="choose_signal">择时信号：{{ signalData[reportData.maxAnnualYield[1]] }}</p>
                <p class="backtestweek pdt5"><span>{{ reportData.maxAnnualYield[0] | safePercentFixedTwo }}</span>, 回测持股周期 <span>{{ reportData.maxAnnualYield[2] }}</span> 天 </p>
            </div>
            <div class="max_win_rise">
                <p>最大成功率</p>
                <p class="choose_signal">择时信号：{{ signalData[reportData.maxWinRate[1]] }}</p>
                <p class="backtestweek pdt5"><span>{{ reportData.maxWinRate[0] | safePercentFixedTwo }}</span>, 回测持股周期 <span>{{ reportData.maxWinRate[2] }}</span> 天 </p>
            </div>
            <div class="report_grade_img" :class="reportData.level | levelType"></div>
        </div>
    </div>

</template>

<script>
    export default {
        data () {
            return {
            }
        },
        props: {
            strategyId: String,
            signalData: Object,
            reportData: Object,
            transactiontype: String,
            query: String
        },
        methods: {
            iwencaiPoint () {
                if (document.getElementsByClassName('strategydetailmain')[0]) {
                    window.TA.log(this.$buriedPoint.strategyDetails.iwencai.replace('_square', '_square_' + this.strategyId))
                } else {
                    window.TA.log(this.$buriedPoint.strategyBacktest.iwencai)
                }
            }
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @import '../../scss/strategybacktest/main.scss';
</style>



// WEBPACK FOOTER //
// src/components/strategybacktest/report-grade.vue